// extracted by mini-css-extract-plugin
export default {"dot":"status-dot_dot__lyXPB","late":"status-dot_late__ovV5n","onTime":"status-dot_onTime__wtuzb"};